module.exports = __webpack_public_path__ + "img/injectionsteps_step2.09653e93.png";